<template>
    <div v-if="show">
        <Alert :alert="alertType" :message="message" />
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Alert from '@/Components/Alert.vue';
import { usePage } from '@inertiajs/vue3';
import translate from '@/Composables/baseVue';

const props = defineProps({
    /**
     * 'site' = warning/critical only (site-wide top banner).
     * 'dashboard' = dashboard threshold only (≤90d, >30d) to avoid duplicating the site banner.
     */
    mode: {
        type: String,
        default: 'site',
    },
});

const license = computed(() => usePage().props.license);

const show = computed(() => {
    if (!license.value?.expires_at || !license.value?.level) {
        return false;
    }

    const level = license.value.level;
    if (props.mode === 'dashboard') {
        return level === 'dashboard';
    }

    return ['warning', 'critical'].includes(level);
});

const alertType = computed(() => {
    return license.value?.level === 'critical' ? 'danger' : 'warning';
});

const message = computed(() => {
    const daysLeft = license.value?.days_left;
    const expiresAt = license.value?.expires_at;

    if (daysLeft === null || daysLeft === undefined) {
        return '';
    }

    if (daysLeft < 0) {
        return translate('Your CANDICE license expired on :date. Please contact Genomnis to renew it.', { date: expiresAt });
    }

    if (daysLeft === 0) {
        return translate('Your CANDICE license expires today (:date). Please contact Genomnis to renew it.', { date: expiresAt });
    }

    return translate('Your CANDICE license expires on :date (:days days left). Please contact Genomnis to renew it.', {
        date: expiresAt,
        days: daysLeft,
    });
});
</script>
